import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics 追蹤
export const useGoogleAnalytics = (measurementId) => {
  const location = useLocation();

  useEffect(() => {
    if (!measurementId) return;

    // 載入 Google Analytics 腳本
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // 初始化 GA
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', measurementId);

    // 清理
    return () => {
      document.head.removeChild(script1);
    };
  }, [measurementId]);

  // 追蹤頁面瀏覽
  useEffect(() => {
    if (!measurementId || !window.gtag) return;
    
    window.gtag('config', measurementId, {
      page_path: location.pathname + location.search,
    });
  }, [location, measurementId]);
};

// Meta (Facebook) Pixel 追蹤
export const useMetaPixel = (pixelId) => {
  const location = useLocation();

  useEffect(() => {
    if (!pixelId) return;

    // 載入 Meta Pixel 腳本
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');

  }, [pixelId]);

  // 追蹤頁面瀏覽
  useEffect(() => {
    if (!pixelId || !window.fbq) return;
    
    window.fbq('track', 'PageView');
  }, [location, pixelId]);
};

// 追蹤事件的輔助函數
export const trackEvent = (eventName, eventParams = {}) => {
  // Google Analytics 事件
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }

  // Meta Pixel 事件
  if (window.fbq) {
    window.fbq('track', eventName, eventParams);
  }
};

// 預定義的追蹤事件
export const trackFormSubmit = (formName) => {
  trackEvent('form_submit', { form_name: formName });
  if (window.fbq) {
    window.fbq('track', 'Lead');
  }
};

export const trackCallClick = (phoneNumber) => {
  trackEvent('call_click', { phone_number: phoneNumber });
  if (window.fbq) {
    window.fbq('track', 'Contact');
  }
};

export const trackCourseView = (courseName) => {
  trackEvent('view_course', { course_name: courseName });
  if (window.fbq) {
    window.fbq('track', 'ViewContent', { content_name: courseName });
  }
};
